<template>
  <Main>
    <template v-slot:breadcrumb>
      <BaseBreadcrumb
        @return="previousPage"
        :items="breadcrumb"
        class="d-none d-sm-flex"
      />
    </template>
    <template v-slot:breadcrumb-mobile>
      <BaseBreadcrumb @return="previousPage" :items="breadcrumb" />
    </template>
    <v-form v-if="economicGroup" ref="form" @submit.prevent="submit">
      <NewCompanyForm
        :value="model"
        :balance-documents-model="balanceDocuments"
        :balance-error-messages="balanceFormErrors"
        :documents-model="otherDocuments"
        @open-balance-modal="onToggleBalanceModal"
        @open-single-document-modal="onToggleSingleDocumentModal"
        @preview-document="onPreviewDocument"
        @remove-document="onRemoveDocument"
        @preview-file="onPreviewFile"
        @remove-file="onRemoveFile"
        @remove-others-documents="onRemoveOthersDocuments"
      >
        <h3 class="gray--text mb-2">
          GRUPO ECONÔMICO: {{ economicGroup.nome }}
        </h3>
        <fragment v-if="isSubsidiary">
          <FormSection :title="textInclusaoFilial">
            <v-col cols="12" class="mb-4">
              <SuggestInput
                v-model="tomador"
                :search-term="search"
                :options="companiesList"
                :label-text="textMatriz"
                placeholder="Razão Social / CNPJ"
                v-bind="defaultFilterProps"
                @search="onSearchCompany"
              />
              <BaseErrorMessages
                v-if="tomadorErrorMessages.length > 0"
                :error-messages="tomadorErrorMessages"
              />
            </v-col>
          </FormSection>
          <v-divider />
        </fragment>
        <FormSection
          :class="isSubsidiary && 'pt-9'"
          :title="companyDetailsTitle"
        >
          <CompanyDetailsFormSection :value="model" />
        </FormSection>
      </NewCompanyForm>
      <BaseFooter>
        <div class="d-flex justify-end">
          <BaseButton
            class="error text-uppercase subtitle-2 font-weight-bold"
            min-width="200"
            :to="{
              name: 'economic_group companies list',
              params: { groupId: this.groupId }
            }"
          >
            CANCELAR
          </BaseButton>
          <BaseButton
            type="submit"
            class="secondary text-uppercase subtitle-2 font-weight-bold ml-5"
            min-width="200"
          >
            ADICIONAR
          </BaseButton>
        </div>
      </BaseFooter>
    </v-form>
    <BalanceModal
      v-if="isBalanceModalOpen"
      v-model="isBalanceModalOpen"
      :form-model="selectBalanceDocumentModel"
      @selected-files="onSelectedBalanceDocuments"
      @preview-file="onPreviewFile"
      @remove-file="onRemoveFile"
      @submit="onCompletedBalanceDocumentSelection"
      @close="onToggleBalanceModal"
    />
    <SingleDocumentModal
      v-model="isDocumentModalOpen"
      :title="documentModalTitle"
      :type-document="documentModalForKey"
      :current-documents="otherDocuments[documentModalForKey]"
      @remove-others-documents="onRemoveOthersDocuments"
      @submit="onCompletedDocumentSelection"
      @close="onToggleDocumentModal"
    />
    <ModalCancelCompany
      @close="closeModalCancel"
      v-model="modalCancel"
      title="SAIR SEM SALVAR"
      text="As alterações não foram salvas. Deseja realmente sair da tela?"
    />
  </Main>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import CompanyMixin from "@/mixins/CompanyMixin";
import SuggestMixin from "@/mixins/SuggestMixin";
import EconomicGroupMixin from "../mixins/EconomicGroupMixin";
import { normalizeCnpj } from "@/utils/documents.js";
import FormSection from "@/components/FormSection.vue";
import CompanyDetailsFormSection from "@/components/form/CompanyDetailsFormSection.vue";
import BalanceModal from "../components/BalanceModal.vue";
import NewCompanyForm from "../components/NewCompanyForm.vue";
import SingleDocumentModal from "../components/SingleDocumentModal.vue";
import SuggestInput from "@/components/SuggestInput.vue";
import { requiredInput } from "@/utils/rules.js";
import ModalCancelCompany from "../../insurance_company/components/ModalCancelInsurance";
import _ from "lodash";
const defaultFilterProps = {
  outlined: true,
  dense: true,
  "background-color": "white",
  class: "filter__icon",
  "append-outer-icon": "fa-search"
};

const successMessageBuilder = {
  tomador: (company, showTomador) => `${showTomador ? "Tomador ": ""}Matriz ${company.nome_fantasia} adicionado`,
  subsidiaria: (company, showTomador) => `${showTomador ? "Tomador ": ""}Filial ${company.nome_fantasia} adicionado`
};

const BREADCRUMB_ADICIONAR_TOMADOR_FILIAL = [
  {
    text: "Adicionar Tomador Matriz ou Filial",
    to: "economic_group view"
  }
];

const BREADCRUMB_ADICIONAR_EMPRESA = [
  {
    text: "Adicionar Empresa",
    to: "economic_group view"
  }
];

export default {
  name: "NewCompany",
  beforeRouteLeave(to, from, next) {
    if (this.cancel || this.formIsPristine()) next();
    this.modalCancel = true;
    this.nextRoute = to;
  },
  mixins: [LoadingRequest, EconomicGroupMixin, CompanyMixin, SuggestMixin],
  created(){
    this.insertValuesOnBreadcrumb();
  },  
  mounted() {
    !this.economicGroup && this.fetchData(this.groupId);
  },
  components: {
    NewCompanyForm,
    BalanceModal,
    SingleDocumentModal,
    FormSection,
    CompanyDetailsFormSection,
    SuggestInput,
    ModalCancelCompany
  },
  data: () => ({
    search: "",
    tomador: null,
    tomadorErrorMessages: [],
    companiesList: [],
    defaultFilterProps,
    isBalanceModalOpen: false,
    isContactModalOpen: false,
    model: { ativo: true, endereco: {}, atividade_principal: {} },
    balanceDocuments: { documents: [] },
    otherDocuments: {
      contrato_social: [],
      estatuto: [],
      ata: [],
      outros: []
    },
    cloneForm: { ativo: true, endereco: {}, atividade_principal: {} },
    cloneBalanceDocuments: { documents: [] },
    cloneOtherDocuments: {
      contrato_social: [],
      estatuto: [],
      ata: [],
      outros: []
    },
    documentModalForKey: null,
    requiredInput,
    oldCNAE: null,
    cancel: false,
    modalCancel: false,
    nextRoute: null,
    breadcrumb: null
  }),
  computed: {
    ...mapState("economic_group", ["economicGroup"]),
    ...mapState("me", ["userAreaIsGarantia"]),
    textMatriz(){
      return this.userAreaIsGarantia ? "Tomador Matriz" : "Matriz";
    },
    textInclusaoFilial() {
      return this.userAreaIsGarantia ? "INCLUSÃO DE TOMADOR FILIAL" : "INCLUSÃO DE FILIAL";
    },
    groupId() {
        return this.$route.params.groupId;
    },
    isSubsidiary() {
      return /subsidiary/.test(this.$route.name);
    },
    companyType() {
      return this.isSubsidiary ? "subsidiaria" : "tomador";
    },
    companyDetailsTitle() {
      if (this.userAreaIsGarantia) {
        return this.isSubsidiary
        ? "DADOS DO TOMADOR FILIAL"
        : "INCLUSÃO DE TOMADOR MATRIZ";
      }
      else {
        return this.isSubsidiary
        ? "DADOS DA FILIAL"
        : "INCLUSÃO DE MATRIZ";
      }
    },
    cloneModel() {
      return {
        ...this.model,
        atividade_principal: {
          ...this.model.atividade_principal
        },
        endereco: {
          ...this.model.endereco
        }
      };
    },
    selectBalanceDocumentModel() {
      return this.balanceDocuments;
    },
    selectDocumentModel() {
      return this.otherDocuments;
    },
    formData() {
      const data = { ...this.model };
      if (this.isSubsidiary) {
        data.subsidiaria_de = this.tomador;
      }
      return data;
    }
  },
  methods: {
    ...mapActions(["suggestCompany"]),
    ...mapActions("economic_group", [
      "findCNAE",
      "findLegalPerson",
      "findCEP",
      "findEconomicGroup",
      "createCompany"
    ]),
    insertValuesOnBreadcrumb() {
      this.breadcrumb = this.userAreaIsGarantia ? BREADCRUMB_ADICIONAR_TOMADOR_FILIAL : BREADCRUMB_ADICIONAR_EMPRESA;
    },
    formIsPristine() {
      return (
        _.isEqual(_.omit(this.cloneForm), _.omit(this.model)) &&
        _.isEqual(this.cloneBalanceDocuments, this.balanceDocuments) &&
        _.isEqual(this.cloneOtherDocuments, this.otherDocuments)
      );
    },
    updateModel(newModel) {
      this.model = newModel;
    },
    closeModalCancel(value) {
      this.cancel = value;
      this.modalCancel = false;
      if (value) {
        this.$router.push({
          name: this.nextRoute.name,
          params: this.nextRoute.params
        });
      }
    },
    previousPage() {
      this.$router.push({
        name: "economic_group companies list",
        params: { groupId: this.groupId }
      });
    },
    onSearchCompany(search, loading) {
      this.performCompanySearch(
        search,
        this.groupId,
        loading,
        companies => (this.companiesList = companies),
        this
      );
    },
    onRemoveOthersDocuments(item) {
      this.otherDocuments[item.tipo_documento.id] = this.otherDocuments[
        item.tipo_documento.id
      ].filter(document =>
        document.id
          ? document.id !== item.id
          : document.arquivo.nome !== item.arquivo.nome
      );
    },
    fetchData(groupId) {
      this.withLoading(this.findEconomicGroup(groupId));
    },
    validate() {
      const hasBalanceDocuments = true;
      if (!hasBalanceDocuments) {
        this.balanceFormErrors = [
          "É preciso adicionar os arquivos de balanço."
        ];
      }
      this.tomadorErrorMessages = this.tomador
        ? []
        : ["É preciso selecionar um tomador matriz"];
      const tomadorValidate =
        !this.isSubsidiary || (this.isSubsidiary && this.tomador);
      return (
        this.$refs.form.validate() && hasBalanceDocuments && tomadorValidate
      );
    },
    submitCompany() {
      return this.submitDocuments(
        this.balanceDocuments,
        this.otherDocuments
      ).then(({ balancos, documentos }) =>
        this.createCompany({
          groupId: this.groupId,
          info: {
            ...this.formData,
            documentos,
            balancos
          }
        })
      );
    },
    submit() {
      if (!this.validate()) {
        return;
      }

      this.withLoading(this.submitCompany()).then(company => {
        this.cancel = true;
        this.$router.push({
          name: "economic_group companies list",
          params: { groupId: this.groupId }
        });
        this.showAlertNotification({
          message: `${successMessageBuilder[this.companyType](
            company,
            this.userAreaIsGarantia
          )} com sucesso.`,
          type: "success"
        });
      });
    }
  },
  watch: {
    "model.cnpj"(value, oldValue) {
      const cnpj = normalizeCnpj(value);
      if (!oldValue || cnpj === normalizeCnpj(oldValue)) {
        return;
      }
      if (cnpj.length === 14) {
        this.findLegalPersonProxy(cnpj);
      }
    },
    "model.atividade_principal.codigo"(value) {
      const cnae = value.replace(/\D/g, "");
      // Evitar de ficar num looping infinito
      if (cnae.length == 7 && this.oldCNAE != cnae) {
        this.findCNAEProxy(cnae);
      }
    }
  }
};
</script>
